
import Vue, { PropType } from 'vue'
import Image from '@/models/Image'

import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'
// import { id } from '@/types/models'

import {
  canShare,
  canShareFiles,
  shareFileFromUrl,
  shareUrl,
} from '@/helpers/share'
import { formatDateTime } from '@/helpers/formatters'

export default Vue.extend({
  components: {
    PlantAvatar,
  },
  props: {
    image: Object as PropType<Image>,
    hidePlants: Boolean,
  },
  data: () => ({
    editNote: undefined as string | undefined,
    submittingNoteUpdate: false,

    showExif: false,
  }),
  computed: {
    // canShareFiles(): boolean {
    //   return !!navigator.canShare
    // },
    // canShare(): boolean {
    //   return !!navigator.share
    // },
    canShare,
    canShareFiles,
  },
  methods: {
    formatDateTime: formatDateTime,
    shareFile() {
      shareFileFromUrl(this.image.url.l, this.image.id)
        .then(() =>
          this.$store.dispatch('snackbars/success', 'shared file(s)!')
        )
        .catch((err) => this.$store.dispatch('snackbars/error', err.message))
    },
    shareUrl() {
      shareUrl(this.image.url.l, {
        title: this.$app.name,
        text: `image from ${this.$app.name}`,
      })
        .then(() => this.$store.dispatch('snackbars/success', 'shared url!'))
        .catch((err) => this.$store.dispatch('snackbars/error', err.message))
    },
    updateNote() {
      this.submittingNoteUpdate = true
      const note: string | null = this.editNote || null

      this.$store
        .dispatch('gardens/images/update', {
          gardenId: this.image.gardenId,
          id: this.image.id,
          updates: { note },
        })
        .then(() => (this.editNote = undefined))
        .then(() => this.$store.dispatch('snackbars/success', `Updated image!`))
        .catch((err: Error) =>
          this.$store.dispatch('snackbars/error', err.message)
        )
        .finally(() => (this.submittingNoteUpdate = false))
    },
    deleteImageWithPrompt(image: Image) {
      if (window.confirm('Do you really want to delete this image?')) {
        this.deleteImage(image)
      }
    },
    deleteImage(image: Image) {
      this.$store
        .dispatch('gardens/images/delete', {
          gardenId: image.gardenId,
          imageId: image.id,
        })
        .then(() => this.$store.dispatch('snackbars/success', `Deleted image!`))
        .catch((err: Error) =>
          this.$store.dispatch('snackbars/error', err.message)
        )
    },
  },
})
